// Used to Update nodes on test if the current entity status is one of the following
export const statusListForDataUpdate = ['draft', 'tested'];

export const maxNestedLoopNodesAllowed = 2;
